import { makeVar } from '@apollo/client'

import { SettingsProps } from 'types/settings'

export const rvSettings = makeVar({
  deposits: {
    selectedAccount: 'ZELLER',
    bsb: undefined,
    accountNumber: undefined,
    accountNumberConfirmation: false,
  },
} as SettingsProps)
